import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { checkCustomerAuthentication, validateOrganization } from '../../../../lib/portal-loaders';

function PortalTickets() {
  return <Outlet />;
}

export const Route = createFileRoute('/org/$orgSlug/portal/tickets')({
  beforeLoad: async ({ params }) => {
    const orgSlug = params.orgSlug as string;

    try {
      // Validate organization and get organization info
      const organizationInfo = await validateOrganization(orgSlug);

      // Check if user has valid customer authentication for this organization
      if (!checkCustomerAuthentication(organizationInfo.organizationId)) {
        throw redirect({
          to: '/org/$orgSlug/portal/login',
          params: { orgSlug: params.orgSlug },
        });
      }
    } catch {
      // If organization validation or authentication fails, redirect to login
      throw redirect({
        to: '/org/$orgSlug/portal/login',
        params: { orgSlug: params.orgSlug },
      });
    }
  },
  component: PortalTickets,
});